<template>
  <RPButton 
    v-if="vehicles?.length > 1"
    theme="secondary" 
    class="justify-between  min-w-[80px] px-4 py-0 bg-card-bg"
    :class="[buttonClass]"
    @click="showSelectVehicleModal = true"
  >
    <div v-if="getSelectedVehicleById" class="flex items-center">
      <RPCarIcon
        :avatar="getSelectedVehicleById.avatarImageName"
        :color="getSelectedVehicleById.avatarColor"
        class="w-6 mr-2 h-fit"
      />
      <span class="px-2">{{ getSelectedVehicleById.nickName }}</span>
    </div>
    <div v-else class="flex items-center">
      <RydIcon icon="history/ryd" class="mr-1" />
      <span class="px-2">{{ $t('history.filter.select_vehicles') }}</span>
    </div>
    <RydIcon icon="symbols/arrow-down" />
  </RPButton>
  <ModalBottom v-if="showSelectVehicleModal || forceSelectVehicle" class="text-left" :customClass="['h-[30vh]', 'pb-3']" @close="closeModal">
    <div class="flex justify-between items-center">
      <p class="rp-fs-16-ln font-semibold">
        {{ $t('history.filter.select_vehicles') }}
      </p>
    </div>

    <ul class="pt-6">
      <li 
        v-for="vehicle in vehicles" 
        :key="vehicle.thingId" 
        class="mb-6 flex items-center"
        :class="{ 'text-tertiary-text': vehicle.thingId === props.selectedVehicleId }"
        @click="onVehicleSelected(vehicle)"
        @keydown.enter="onVehicleSelected(vehicle)"
      >
        <RPCarIcon :avatar="vehicle.avatarImageName" :color="vehicle.avatarColor" class="w-6 mr-2 h-auto" />
        <button class="h-fit">
          {{ vehicle.nickName }}
        </button>
      </li>
    </ul>
    <RPButton
      outline
      class="mb-6"
      :disabled="props.forceSelectVehicle || !props.selectedVehicleId"
      @click="showSelectVehicleModal = false"
    >
      {{ $t('general_cta.close') }}
    </RPButton>
  </ModalBottom>
</template>
<script setup lang="ts">
import RPCarIcon from '@/components/CarsSVGComponents/RPCarIcon.vue';
import ModalBottom from '@/components/ModalBottom.vue';
import RPButton from '@/components/RPButton/RPButton.vue';
import RydIcon from '@/components/RydIcon/RydIcon.vue';

import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/store/auth/auth';
import { ref, computed, PropType } from 'vue';
import { useRouter } from 'vue-router';

import { ThingAvatars } from '@/api/user';



const { t } = useI18n();
const router = useRouter();
const authState = useAuthStore();

const showSelectVehicleModal = ref(false);

const props = defineProps({
  selectedVehicleId: {
    type: String,
    default: null,
  },
  buttonClass: {
    type: [String, Array, Object],
    default: '',
  },
  forceSelectVehicle: {
    type: Boolean,
    default: false,
  },
});

const vehicles = computed<ThingAvatars[]>(() => authState.userPreferences);
const getSelectedVehicleById = computed(() => {
  return vehicles.value.find((vehicle) => vehicle.thingId === props.selectedVehicleId);
});
const emit = defineEmits(['onVehicleSelected']);

const onVehicleSelected = (vehicle: ThingAvatars) => {
  emit('onVehicleSelected', vehicle);
  showSelectVehicleModal.value = false;
};

const closeModal = () => {
  if (props.forceSelectVehicle || !props.selectedVehicleId) return;
  showSelectVehicleModal.value = false;
};
</script>